import React from "react";
import { Route } from "react-router";
import { Switch } from "react-router";
import ListPage from "./pages/admin/ListPage";
import EditPage from "./pages/admin/EditPage";
import CreatePage from "./pages/admin/CreatePage";
import AuthRoute from "../auth/components/routes/AuthRoute";
import NotFound from "../pages/NotFound";

export default function Degrees({ path }: { path: string }) {
  return (
    <Route path={path}>
      <Switch>
        <AuthRoute exact path={path} roles={[0, 1]} component={ListPage} />
        <AuthRoute
          roles={[0, 1]}
          component={CreatePage}
          path={`${path}/create`}
        />
        <AuthRoute
          roles={[0, 1]}
          component={EditPage}
          path={`${path}/:id/edit`}
        />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
